/**
 * Represents the symbol for the PaginatedSpacesRepository.
 */
export const PaginatedSpacesRepository = Symbol('GetPaginatedSpacesService');
